import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InactiveOrganizationIcon = (props: IconProps) => (
  <Icon w="40px" h="40px" viewBox="0 0 40 40" {...props}>
    <circle cx="20" cy="20" r="20" />
    <path d="M14.6666 10.6667h2.6667v2.6667h-1.2L20 17.2V16h10.6666v11.8667l2.6667 2.6667v-17.2H20V8.00002h-9.2l3.8666 3.86668v-1.2Zm10.6667 8H28v2.6667h-2.6667v-2.6667Zm-19.6-12.26668-1.6 1.73334 2.53333 2.53334V32H28l4 4 1.7333-1.7333-28-27.86668ZM12 29.3334H9.3333v-2.6667H12v2.6667ZM12 24H9.3333v-2.6666H12V24Zm0-5.3333H9.3333V16H12v2.6667Zm5.3333 10.6667h-2.6667v-2.6667h2.6667v2.6667Zm0-5.3334h-2.6667v-2.6666h2.6667V24ZM20 29.3334v-2.6667h2.6666l2.6667 2.6667H20Z" />
  </Icon>
);

export default memo(InactiveOrganizationIcon);
